import axiosCommon from '@/axios-common/axios-common';
import { FullCalendar } from 'vue-full-calendar';
import swal from 'sweetalert2';
import moment from 'moment';

export default {
    name: 'eventDashboard',
    dependencies: ['localeService'],
    components: {
        FullCalendar,
    },
    mounted() {
        this.initialize()
    },
    data() {
        let vm = this;
        return {
            events: [],
            fullCalendarConfig: {
                defaultView: 'month',
                eventClick: function (calEvent, jsEvent, view) {
                    vm.getEventById(parseInt(calEvent.className[0]));
                }
            },
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            return vm.getFellows()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.events = res.data;
                        vm.originalEvents = vm.events.map((event) => event);
                        vm.transformEvents();
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        transformEvents() {
            let vm = this;
            vm.events = vm.events.map(function (event) {
                let transformedEvent = {
                    title: `${event.name}\nPlace: ${event.place}`,
                    start: event.date,
                    end: event.date,
                    className: `${event.id}`
                }
                return transformedEvent;
            });
        },
        getEventById(id) {
            let vm = this;
            let selectedEvent = vm.originalEvents.filter((originalEvent) => originalEvent.id === id);
            swal({
                title: `${selectedEvent[0].name}`,
                type: 'info',
                allowOutsideClick: false,
                html:
                    `
                    <table>
                        <thead>
                            <th>Place</th>
                            <th>Date</th>
                            <th>Attachment</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>${selectedEvent[0].place}</td>
                                <td>${moment(selectedEvent[0].date).format('DD-MMM-YYYY')}</td>
                                <td>${selectedEvent[0].attachments.length > 0 ? '<a href="' + selectedEvent[0].attachments[0].url + '" target="_blank">' + selectedEvent[0].attachments[0].fileName + '</a>' : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                  `,
                showCloseButton: true,
                showCancelButton: false,
            });
        },
        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getFellows()
                .then(function (res) {
                    vm.events = vm.events.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        getFellows() {
            let vm = this;
            return axiosCommon.get(`o/events?language=${vm.localeService.getCurrentLocale()}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/event-dashboard/event-dashboard.js